import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/DeleteModal.css';

const DeleteConfirmationModal = ({ show, onHide, onConfirm }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full">
        <div className="border-b p-4">
          <h3 className="text-lg font-semibold">Confirm Delete</h3>
        </div>
        <div className="p-4">
          <p>Are you sure you want to delete this item?</p>
        </div>
        <div className="flex justify-end border-t p-4">
          <button
            className="mr-2 px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 focus:outline-none"
            onClick={onHide}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none"
            onClick={onConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

DeleteConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteConfirmationModal;
